import React, { PureComponent } from 'react';
import MapContainer from './components/Map/MapContainer';
import Splash from './components/Splash/Splash';
import FilterSidebar from './components/Sidebars/Filter/Filter';
import FilterButton from './components/common/Buttons/FilterButton';
import LokalplanSidebar from './components/Sidebars/Lokalplan/Lokalplan';
import SearchButton from './components/common/Buttons/SearchButton';
import SearchSidebar from './components/Sidebars/Search/Search';
import TilesLoading from './components/Map/TilesLoading';
import { kommuner as getKommuner } from './api/dawa';
import { lokalplanArraysAreEqual, hoveredplanArraysAreEqual } from './util';
import { ILokalplan } from './Interfaces/ILokalplan';
import { IKommune } from './Interfaces/IKommune';
import { Marker } from 'mapbox-gl';
import {
  // differenceInMinutes,
  differenceInDays,
} from 'date-fns';
import HistorikTopbar from './components/Sidebars/Historik/HistorikTopbar';
import HistorikSidebar from './components/Sidebars/Historik/HistorikSidebar';
const TOKEN: string =
  'pk.eyJ1IjoiaGFha3NldGgiLCJhIjoiY2pxcDE1bGdnMGpvdzQzbnZ0dTdhaHk2MyJ9.AIY9AFW4USpSUDOQxEQD-w';
const LATITUDE: number = 55.7;
const LONGITUDE: number = 12.5;
const ZOOM: number = 10;

class App extends PureComponent<IAppProps, IAppState> {
  constructor(props) {
    super(props);
    let showSplash = true;
    let selectedKommune = undefined;
    if (localStorage.getItem('splashScreenLastShown')) {
      const splashScreenLastShown = new Date(
        localStorage.getItem('splashScreenLastShown')
      );
      if (differenceInDays(new Date(), splashScreenLastShown) < 1) {
        showSplash = false;
      }
    }
    if (localStorage.getItem('selectedKommune')) {
      selectedKommune = JSON.parse(localStorage.getItem('selectedKommune'));
    }
    this.state = {
      currentLokalplan: undefined,
      clickedLokalplans: [],
      hoveredPlans: [],
      style: undefined,
      filterToggled: false,
      searchToggled: false,
      marker: undefined,
      searchResult: [],
      lokalPlanerMapSearchResult: [],
      lokalplanerLoading: false,
      showSplash,
      kommuner: [],
      selectedKommune,
      historiskeLokalplaner: [],
      historiskeLokalplanerLoading: false,
      historiskeLokalplanerToggled: false,
      triggerHistoriskeLokalplaner: false,
      currentHistoriskeLokalplan: undefined,
    };
  }
  componentDidMount() {
    getKommuner().then(kommuner => this.setState({ kommuner }));
  }
  setCurrentLokalplan = (currentLokalplan: ILokalplan) => {
    if (currentLokalplan) {
      this.setFilterToggled(false);
      this.setSearchToggled(false);
    }
    this.setState({ currentLokalplan });
  };
  setClickedLokalplans = clickedLokalplans => {
    if (
      !lokalplanArraysAreEqual(clickedLokalplans, this.state.clickedLokalplans)
    ) {
      this.setState({ clickedLokalplans });
    }
  };
  setHoveredPlans = hoveredPlans => {
    if (!hoveredplanArraysAreEqual(hoveredPlans, this.state.hoveredPlans)) {
      this.setState({ hoveredPlans });
    }
  };
  setStyle = style => {
    this.setState({ style });
  };
  toggleFilter = () => {
    this.setState({ filterToggled: !this.state.filterToggled });
  };
  setFilterToggled = filterToggled => {
    if (filterToggled) {
      this.setHistoriskeLokalplaner([]);
      this.setClickedLokalplans([]);
      this.setCurrentLokalplan(undefined);
      this.setHistoriskeLokalplanerToggled(false);
    }
    this.setState({ filterToggled });
  };
  setSearchToggled = searchToggled => {
    if (searchToggled) {
      this.setHistoriskeLokalplaner([]);
      this.setClickedLokalplans([]);
      this.setCurrentLokalplan(undefined);
      this.setHistoriskeLokalplanerToggled(false);
    }
    this.setState({ searchToggled });
  };
  setMarker = marker => {
    this.setState({ marker });
  };
  setSearchResult = searchResult => {
    this.setState({ searchResult });
  };
  setLokalplanerLoading = lokalplanerLoading => {
    this.setState({ lokalplanerLoading });
  };
  setLokalPlanerMapSearchResult = lokalPlanerMapSearchResult => {
    this.setState({ lokalPlanerMapSearchResult });
  };
  setHistoriskeLokalplanerLoading = historiskeLokalplanerLoading => {
    this.setState({ historiskeLokalplanerLoading });
  };
  setHistoriskeLokalplaner = historiskeLokalplaner => {
    this.setState({ historiskeLokalplaner });
  };
  setTriggerHistoriskeLokalplaner(triggerHistoriskeLokalplaner) {
    this.setState({ triggerHistoriskeLokalplaner });
  }
  setHistoriskeLokalplanerToggled = historiskeLokalplanerToggled => {
    if (historiskeLokalplanerToggled) {
      this.setTriggerHistoriskeLokalplaner(false);
    }
    this.setState({
      historiskeLokalplanerToggled,
      historiskeLokalplaner: [],
      currentHistoriskeLokalplan: undefined,
    });
  };
  setCurrentHistoriskeLokalplan = currentHistoriskeLokalplan => {
    this.setState({ currentHistoriskeLokalplan });
  };
  onSearchClose = () => {
    this.setSearchToggled(false);
  };

  onSearchListItemClick = lokalplan => {
    this.setClickedLokalplans([lokalplan]);
    this.setCurrentLokalplan(lokalplan);
  };
  onSearchResult = result => {
    this.setSearchResult(result);
  };
  onGoClick = kommune => {
    this.setState({ showSplash: false, selectedKommune: kommune });
    localStorage.setItem('splashScreenLastShown', new Date().toISOString());
    localStorage.setItem('selectedKommune', JSON.stringify(kommune));
  };
  componentDidUpdate(prevprops: IAppState, prevState: IAppState) {
    if (prevState.currentLokalplan !== this.state.currentLokalplan) {
      this.setState({ historiskeLokalplanerToggled: false });
    }
  }
  render() {
    const {
      currentLokalplan,
      clickedLokalplans,
      hoveredPlans,
      filterToggled,
      searchToggled,
      style,
      marker,
      searchResult,
      lokalPlanerMapSearchResult,
      lokalplanerLoading,
      showSplash,
      kommuner,
      selectedKommune,
      historiskeLokalplanerLoading,
      historiskeLokalplaner,
      historiskeLokalplanerToggled,
      currentHistoriskeLokalplan,
    } = this.state;
    return (
      <div className="App">
        <MapContainer
          token={TOKEN}
          latitude={LATITUDE}
          longitude={LONGITUDE}
          zoom={ZOOM}
          currentLokalplan={currentLokalplan}
          setCurrentLokaplan={this.setCurrentLokalplan}
          clickedLokalplans={clickedLokalplans}
          setClickedLokalplans={this.setClickedLokalplans}
          hoveredPlans={hoveredPlans}
          setHoveredPlans={this.setHoveredPlans}
          style={style}
          setStyle={this.setStyle}
          marker={marker}
          setMarker={this.setMarker}
          searchToggled={searchToggled}
          searchResult={searchResult}
          lokalPlanerMapSearchResult={lokalPlanerMapSearchResult}
          setLokalPlanerMapSearchResult={this.setLokalPlanerMapSearchResult}
          lokalplanerLoading={lokalplanerLoading}
          setLokalplanerLoading={this.setLokalplanerLoading}
          selectedKommune={selectedKommune}
          setHistoriskeLokalplanerLoading={this.setHistoriskeLokalplanerLoading}
          setHistoriskeLokalplanerToggled={this.setHistoriskeLokalplanerToggled}
          setHistoriskeLokalplaner={this.setHistoriskeLokalplaner}
          setCurrentHistoriskeLokalplan={this.setCurrentHistoriskeLokalplan}
          currentHistoriskeLokalplan={currentHistoriskeLokalplan}
        />
        <Splash
          show={showSplash}
          onGoClick={this.onGoClick}
          kommuner={kommuner}
        />
        <FilterButton
          onClick={() => {
            this.setSearchToggled(false);
            this.setFilterToggled(!filterToggled);
          }}
          toggled={filterToggled}
          topbarToggled={clickedLokalplans.length > 0}
        />
        <SearchButton
          toggled={searchToggled}
          onClick={() => {
            this.setSearchToggled(!searchToggled);
            this.setFilterToggled(false);
          }}
          topbarToggled={clickedLokalplans.length > 0}
        />
        <TilesLoading
          show={lokalplanerLoading}
          sidebarToggled={
            this.state.searchToggled ||
            this.state.filterToggled ||
            this.state.currentLokalplan !== undefined
          }
        />
        <LokalplanSidebar
          clickedLokalplans={clickedLokalplans}
          onClose={() => {
            this.setClickedLokalplans([]);
            this.setCurrentLokalplan(undefined);
          }}
          onListItemHover={this.setHoveredPlans}
          hoveredPlans={hoveredPlans}
          currentLokalplan={currentLokalplan}
          setCurrentLokaplan={this.setCurrentLokalplan}
          canShow={!historiskeLokalplanerToggled}
        />
        <HistorikTopbar
          toggled={historiskeLokalplanerToggled}
          loading={historiskeLokalplanerLoading}
          historiskeLokalplaner={historiskeLokalplaner}
          currentHistoriskeLokalplan={currentHistoriskeLokalplan}
          setCurrentHistoriskeLokalplan={this.setCurrentHistoriskeLokalplan}
        />
        <HistorikSidebar
          toggled={historiskeLokalplanerToggled}
          loading={historiskeLokalplanerLoading}
          lokalplan={currentHistoriskeLokalplan}
          onClose={() => {
            this.setHistoriskeLokalplanerToggled(false);
          }}
          hoveredPlans={hoveredPlans}
          onListItemHover={this.setHoveredPlans}
          clickedLokalplans={clickedLokalplans}
        />
        <FilterSidebar
          onToggle={this.toggleFilter}
          toggled={filterToggled && !currentLokalplan}
        />
        <SearchSidebar
          toggled={searchToggled && !currentLokalplan}
          onClose={this.onSearchClose}
          onListItemClick={this.onSearchListItemClick}
          onSearchResult={this.onSearchResult}
          lokalPlaner={lokalPlanerMapSearchResult}
        />
      </div>
    );
  }
}

interface IAppProps {}

interface IAppState {
  currentLokalplan: ILokalplan;
  clickedLokalplans: Array<ILokalplan>;
  hoveredPlans: Array<number>;
  style: any;
  filterToggled: boolean;
  searchToggled: boolean;
  marker: Marker;
  searchResult: Array<any>;
  lokalPlanerMapSearchResult: Array<ILokalplan>;
  lokalplanerLoading: boolean;
  historiskeLokalplanerToggled: boolean;
  historiskeLokalplanerLoading: boolean;
  historiskeLokalplaner: ILokalplan[];
  currentHistoriskeLokalplan: ILokalplan;
  triggerHistoriskeLokalplaner: boolean;
  showSplash: boolean;
  kommuner: Array<IKommune>;
  selectedKommune: IKommune;
}

export default App;
